import { Vue } from 'vue-property-decorator'
import AppClientForm from '@core/components/AppClientForm.vue'
import { Component } from 'vue'

export function clientFormWrapper (title: string, component: Component, key: string) {
  return Vue.component('clientFormWrapper', {
    render (h) {
      return h(AppClientForm, {
        props: {
          title
        },
        scopedSlots: {
          default: ({ client, clientIndex, kycForm }) => {
            return h(
              component, {
                props: {
                  model: client[key],
                  clientIndex,
                  kycForm
                }
              }
            )
          }
        }
      })
    }
  })
}

export async function clientFormLoader (title: string, key: string, componentPromise: Promise<typeof import('*.vue')>) {
  const component = await componentPromise
  return Promise.resolve(
    clientFormWrapper(title, component.default, key)
  )
}
